<template>
  <div class="imgView">
    <!-- 图片预览 -->
    <el-image-viewer
      v-show="imgViewShow"
      :url-list="imgList"
      :on-close="closeImgView"
    ></el-image-viewer>
  </div>
</template>

<script>
export default {
  name: 'ImageView',
  props: {
    imgList: {
      type: Array,
      default: () => [],
    },
    imgViewShow: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    closeImgView() {
      this.$emit('closeImgView')
    },
  },
}
</script>

